<template>
  <div style="width:100%">
    <p class="is-size-6 has-text-primary">Details geselecteerde {{ typeString }} doorvoer:</p>
    <table class="printblock-table">
      <tr>
        <td>Type:</td>
        <editable
          :editing="editMode"
          v-model="selectedPenetrant.type"
          type="select"
          :dataSelect="typeData"
          :iconBool="true"
          :tooltip="true"
        ></editable>
        <td>Isolatie:</td>
        <editable :editing="editMode" v-model="selectedPenetrant.isolation"></editable>
      </tr>
      <tr v-if="systemData != undefined">
        <td>Systeem:</td>
        <editable
          colspan="3"
          :editing="editMode"
          v-model="selectedPenetrant.system"
          type="select"
          :dataSelect="systemData"
          :tooltip="true"
        ></editable>
      </tr>
      <tr v-if="sizeCategoryList != undefined">
        <td>{{ sizeCategoryTitle }}</td>
        <editable
          :editing="editMode"
          type="select"
          v-model.number="selectedPenetrant.sizeCategory"
          :dataSelect="sizeCategoryList"
        ></editable>
        <td>Lengte:</td>
        <editable :editing="editMode" type="number" v-model.number="selectedPenetrant.length"></editable>
      </tr>
      <tr>
        <td>Aantal:</td>
        <editable :editing="editMode" type="number" v-model.number="selectedPenetrant.count"></editable>
        <td>Complexiteit:</td>
        <editable :editing="editMode" type="number" v-model.number="selectedPenetrant.complexityFactor"></editable>
      </tr>
    </table>
  </div>
</template>

<script>
import editable from '@/components/Projects/editable.vue'
import bigData from './bigData.js'
export default {
  components: {
    editable
  },
  props: {
    selectedPenetrant: {
      type: Object
    },
    editMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      ...bigData.data(),
      typeString: '',
      initBool: false
    }
  },
  computed: {
    typeData: function() {
      console.log(this.selectedPenetrant.mainType)
      if (this.selectedPenetrant.mainType != undefined) {
        const value = this.selectedPenetrant.mainType
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.typeString = value
        switch (value) {
          case 'loos':
            return this.emptyTypes
            break
          case 'lucht':
            return this.mechanicalTypes
            break
          case 'elektra':
            return this.electricTypes
            break
          case 'buis / pijp':
            return this.plumbingTypes
            break
          case 'lineaire voeg':
            return this.jointTypes
            break
          case 'actie':
            return this.actionTypes
            break
          default:
            return []
            break
        }
      } else {
        return this.findType()
      }
    },
    systemData: function() {
      return this.typeData.find(e => e.code == this.selectedPenetrant.type).systems
    },
    sizeCategoryTitle: function() {
      return this.typeData.find(e => e.code == this.selectedPenetrant.type).sizeCategoryTitle
    },
    sizeCategoryList: function() {
      return this.typeData.find(e => e.code == this.selectedPenetrant.type).sizeCategories
    }
  },
  watch: {
    selectedPenetrant: function(val) {
      console.log(val)
      //  this.$emit('input', val.code)
    }
  },
  beforeUpdate: function() {
    if (this.selectedPenetrant.mainType != undefined) {
      this.selectedPenetrant.type = this.typeData[0].code
      if (this.systemData != undefined) this.selectedPenetrant.system = this.systemData[0].code
      if (this.sizeCategoryList != undefined) this.selectedPenetrant.sizeCategory = this.sizeCategoryList[0]
    }
  },
  methods: {
    findType() {
      if (this.emptyTypes.find(e => e.code == this.selectedPenetrant.type) != null) {
        this.typeString = 'empty'
        return this.emptyTypes
      }
      if (this.mechanicalTypes.find(e => e.code == this.selectedPenetrant.type) != null) {
        this.typeString = 'lucht'
        return this.mechanicalTypes
      }
      if (this.electricTypes.find(e => e.code == this.selectedPenetrant.type) != null) {
        this.typeString = 'elektra'
        return this.electricTypes
      }
      if (this.plumbingTypes.find(e => e.code == this.selectedPenetrant.type) != null) {
        this.typeString = 'buis / pijp'
        return this.plumbingTypes
      }
      if (this.jointTypes.find(e => e.code == this.selectedPenetrant.type) != null) {
        this.typeString = 'lineaire voeg'
        return this.jointTypes
      }
      if (this.actionTypes.find(e => e.code == this.selectedPenetrant.type) != null) {
        this.typeString = 'actie'
        return this.actionTypes
      }
      console.log("can't find the type of existing penetrant")
    }
  }
  // addPenetrant(val) {
  //   this.addPenetrantBool = true
  //   const newPenetrant = new Object()
  //   newPenetrant.mainType = this.listChoise
  //   newPenetrant.type = ''
  //   newPenetrant.isolation = ''
  //   newPenetrant.system = ''
  //   newPenetrant.sizeCategory = ''
  //   newPenetrant.length = 0
  //   newPenetrant.count = 1
  //   newPenetrant.complexityFactor = 1
  //   newPenetrant.openingId = this.openingData.openingId
  //   this.openingData.penetrants.push(newPenetrant)
  //   this.selectedPenetrant = this.openingData.penetrants.length - 1
  //   this.newPenetrants.push(newPenetrant)
  //   this.listChoise = 'Klik hier om een nieuwe opening toe te voegen'
  // }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/Projects/AddPenetrant.vue